module.exports = __webpack_public_path__ + "img/worklists.fc44a985.svg";